import { render, staticRenderFns } from "./VanSelectPickerMultiple.vue?vue&type=template&id=68183676&scoped=true"
import script from "./VanSelectPickerMultiple.vue?vue&type=script&lang=js"
export * from "./VanSelectPickerMultiple.vue?vue&type=script&lang=js"
import style0 from "./VanSelectPickerMultiple.vue?vue&type=style&index=0&id=68183676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68183676",
  null
  
)

export default component.exports